<template>
  <scoped>
    <table v-if="items">
      <thead>
        <tr>
          <th>
            Status
          </th>
          <th>
            Type
          </th>
          <th>
            Number
          </th>
          <th>
            Reference
          </th>
          <th>
            Billed At
          </th>
          <th>
            Relation
          </th>
        </tr>
      </thead>
      <tbody v-if="items.length > 0">
        <tr
          v-for="(order, index) in items"
          :key="order.id"
          :class="{'selected' : selectedIndex == index}"
          @click="select(index)"
        >
          <td>
            {{ order.status }}
          </td>
          <td>
            {{ order.type }}
          </td>
          <td>
            {{ order.number }}
          </td>
          <td>
            {{ order.reference }}
          </td>
          <td>
            {{ printDate(order.billedAt) }}
          </td>
          <td>
            <template v-if="order.customer">
              {{ order.customer.name }}
            </template>
            <template v-if="order.supplier">
              {{ order.supplier.name }}
            </template>
          </td>
        </tr>
      </tbody>
    </table>
  </scoped>
</template>

<script setup lang="ts">
  import {Order} from "@/endpoints/rutsolve/gql/generated/graphql"
  import {nextTick} from "vue"

  defineProps({
    items: {
      default: null,
      required: true,
      type: Array<Order>
    }
  })

  const emits = defineEmits(["select"])

  const selectedIndex = defineModel("selectedIndex", {
    default: null,
    required: false,
    type: Number
  })

  async function select(index: number) {
    selectedIndex.value = index
    await nextTick()
    emits("select")
  }

  function printDate(date: string): string {
    if (!date) {
      return ""
    }
    return new Date(date).toLocaleDateString("nl-NL")
  }
</script>

<style scoped>
  table {
    > tbody {
      > tr {
        &:hover {
          background-color: var(--theme-color-secondary);
          color: var(--color-white);
          cursor: pointer;
        }

        &.selected {
          background-color: var(--theme-color-secondary);
          color: var(--color-white);
          cursor: default;
        }
      }
    }
  }
</style>
